import {
  FETCH_AFFILIATE_LINKS_START,
  FETCH_AFFILIATE_LINKS_SUCCESS,
  FETCH_AFFILIATE_LINKS_ERROR,
  CREATE_AFFILIATE_LINK_START,
  CREATE_AFFILIATE_LINK_SUCCESS,
  CREATE_AFFILIATE_LINK_ERROR,
  DELETE_AFFILIATE_LINK_START,
  DELETE_AFFILIATE_LINK_SUCCESS,
  DELETE_AFFILIATE_LINK_ERROR,
  FETCH_AFFILIATE_STATS_START,
  FETCH_AFFILIATE_STATS_SUCCESS,
  FETCH_AFFILIATE_STATS_ERROR,
  FETCH_COUPON_CODES_START,
  FETCH_COUPON_CODES_SUCCESS,
  FETCH_COUPON_CODES_ERROR,
  CREATE_COUPON_CODE_START,
  CREATE_COUPON_CODE_SUCCESS,
  CREATE_COUPON_CODE_ERROR,
  DELETE_COUPON_CODE_START,
  DELETE_COUPON_CODE_SUCCESS,
  DELETE_COUPON_CODE_ERROR,
} from '../../Action/actionTypes'

const initialState = {
  affiliateLinks: [],
  couponCodes: [],
  selectedLinkStats: null,

  linksLoading: false,
  linksError: null,

  createLinkLoading: false,
  deleteLinkLoading: false,

  statsLoading: false,
  statsError: null,

  couponsLoading: false,
  couponsError: null,

  createCouponLoading: false,
  deleteCouponLoading: false,
}

const affiliateReducer = (state = initialState, action) => {
  switch (action.type) {
    // ── Links ──
    case FETCH_AFFILIATE_LINKS_START:
      return { ...state, linksLoading: true, linksError: null }
    case FETCH_AFFILIATE_LINKS_SUCCESS:
      return { ...state, linksLoading: false, affiliateLinks: action.payload }
    case FETCH_AFFILIATE_LINKS_ERROR:
      return { ...state, linksLoading: false, linksError: action.payload }

    case CREATE_AFFILIATE_LINK_START:
      return { ...state, createLinkLoading: true }
    case CREATE_AFFILIATE_LINK_SUCCESS:
      return {
        ...state,
        createLinkLoading: false,
        affiliateLinks: [action.payload, ...state.affiliateLinks],
      }
    case CREATE_AFFILIATE_LINK_ERROR:
      return { ...state, createLinkLoading: false }

    case DELETE_AFFILIATE_LINK_START:
      return { ...state, deleteLinkLoading: true }
    case DELETE_AFFILIATE_LINK_SUCCESS:
      return {
        ...state,
        deleteLinkLoading: false,
        affiliateLinks: state.affiliateLinks.filter((l) => l.id !== action.payload),
      }
    case DELETE_AFFILIATE_LINK_ERROR:
      return { ...state, deleteLinkLoading: false }

    // ── Stats ──
    case FETCH_AFFILIATE_STATS_START:
      return { ...state, statsLoading: true, statsError: null, selectedLinkStats: null }
    case FETCH_AFFILIATE_STATS_SUCCESS:
      return { ...state, statsLoading: false, selectedLinkStats: action.payload }
    case FETCH_AFFILIATE_STATS_ERROR:
      return { ...state, statsLoading: false, statsError: action.payload }

    // ── Coupons ──
    case FETCH_COUPON_CODES_START:
      return { ...state, couponsLoading: true, couponsError: null }
    case FETCH_COUPON_CODES_SUCCESS:
      return { ...state, couponsLoading: false, couponCodes: action.payload }
    case FETCH_COUPON_CODES_ERROR:
      return { ...state, couponsLoading: false, couponsError: action.payload }

    case CREATE_COUPON_CODE_START:
      return { ...state, createCouponLoading: true }
    case CREATE_COUPON_CODE_SUCCESS:
      return {
        ...state,
        createCouponLoading: false,
        couponCodes: [action.payload, ...state.couponCodes],
      }
    case CREATE_COUPON_CODE_ERROR:
      return { ...state, createCouponLoading: false }

    case DELETE_COUPON_CODE_START:
      return { ...state, deleteCouponLoading: true }
    case DELETE_COUPON_CODE_SUCCESS:
      return {
        ...state,
        deleteCouponLoading: false,
        couponCodes: state.couponCodes.filter((c) => c.id !== action.payload),
      }
    case DELETE_COUPON_CODE_ERROR:
      return { ...state, deleteCouponLoading: false }

    default:
      return state
  }
}

export default affiliateReducer
